module.exports = __webpack_public_path__ + "img/bmpclogo.252dc361.png";